var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mx-3"
  }, [_c('v-alert', {
    attrs: {
      "color": "red lighten-2",
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("WIP")))])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }